import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { FamilleDeRisque } from '../models/dossiers/famillesDeRisque';
import { Mesure } from '../models/dossiers/mesures';

const resource = 'FamillesDeRisque'

export default class FamillesDeRisqueRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<FamilleDeRisque>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
